<template>
    <div v-cloak>
        <b-alert
            v-if="level > getLevel(student.level)"
            variant="warning"
            show
        >
            <h4 class="alert-heading">Previous level units to be completed prior of next level!</h4>
            <hr>
            If you have completed the previous level you will need to contact the Administration Team
        </b-alert>
    </div>
</template>

<script>
/* global _ */
/* global Noty */
/* global axios */

export default {
    name: 'LevelWarning',
    props: {
        student: {
            type: Object,
            required: true,
        },
    },
    computed: {
        level() {
            return Number(this.$route.path.split('/')[3].slice(-1));
        },
    },
    watch: {
        $route() {
            document.title = `Level ${this.level}`;
        },
    },
    methods: {
        getLevel(level) {
            let current_level = 0;
            switch (level) {
                case 'Cluster 1':
                case 'Level 1':
                    current_level = 1;
                    break;
                case 'Cluster 2':
                case 'Level 2':
                    current_level = 2;
                    break;
                case 'Cluster 3':
                case 'Level 3':
                    current_level = 3;
                    break;
                case 'Cluster 4':
                case 'Level 4':
                    current_level = 4;
                    break;
                case 'Pipeline':
                default:
                    current_level = 5;
                    break;
            }
            return current_level;
        },
    },
};
</script>
